import { hasGates } from 'utils/Access'
export const WIDGET_SETINGS_V3_ROUTE = 'widget-settings'
export const WIDGET_SETINGS_ROUTE = 'widget'
export const ENHANCED_WIDGET_SETTINGS_ROUTE = 'enhanced-widget-settings'

export const getWidgetSettingsUrl = () => {
  if (hasGates('has_enhanced_widget_settings')) {
    return ENHANCED_WIDGET_SETTINGS_ROUTE
  } else {
    return hasGates('has_widget_v3')
      ? WIDGET_SETINGS_V3_ROUTE
      : WIDGET_SETINGS_ROUTE
  }
}
